<template>
  <search-suggestions-form :submit-loading="submitLoading"
                           :title="$t('searchSuggestions.create.title')"
                           @submit="onSubmit">
  </search-suggestions-form>
</template>
<script>
  import SearchSuggestionsForm from './SearchSuggestionsForm'
  import SearchSuggestionsService from 'src/services/SearchSuggestionsService'

  export default {
    components: {
      SearchSuggestionsForm,
    },
    data () {
      return {
        submitLoading: false,
        suggestion: null,
      }
    },
    methods: {
      async onSubmit (data) {
        try {
          this.submitLoading = true
          await SearchSuggestionsService.create(data)
          this.$router.push('/settings/search-suggestions')
        } finally {
          this.submitLoading = false
        }
      },
    },
  }
</script>
<style>
</style>
